import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent';
import { Fab, Grid, FormControl, InputLabel, Select, Input, MenuItem } from '@material-ui/core';
import EtapeProiectAdd from '../../commons/dialogs/EtapeProiectAdd'
import Ws from '../../providers/Ws';
import FromServer from './FromServer';
import Utils from '../../providers/Utils';
import EtapeListBeta from '../../commons/EtapeListBeta'
import InsertUpdateTask from '../../commons/dialogs/InsertUpdateTask'
import LocalStorage from '../../providers/LocalStorage';
import InsertUpdateEtapa from '../../commons/dialogs/InsertUpdateEtapa'
import AlertDialog from '../../commons/dialogs/AlertDialog'
import GanttEtapeWeekView from '../../commons/GanttEtapeWeekView'
import GanttProiecteMonthView from '../../commons/GanttProiecteMonthView'
import GanttProiectIntegral from '../../commons/GanttProiectIntegral'
import GanttEtapeMonthView from '../../commons/GanttEtapeMonthView'  
import GanttTaskuriFullView from '../../commons/GanttTaskuriFullView'
import avatar from '../../Pics/avatar.jpg'
import TimpiLucru from '../../commons/dialogs/TimpiLucru';
import ButtonsModules from '../../commons/ButtonsModules';
import TaskuriList from '../../commons/TaskuriList';
import AppBar from '../../commons/AppBar';

export default class UserEtape extends SpecificComponent {
    constructor(props) {
      super(props);
      this.ganttChange = React.createRef()
       this.state = {

        etape:[],
        etapeStatus:[{
            id:'Finalizata',
            text:this.dictionary.proiecte.status.finalizata
        },
        {
            id:'InLucru',
            text:this.dictionary.proiecte.status.inlucru
        },
        {
            id:'Blocat',
            text:this.dictionary.proiecte.status.blocat
        }
    ],
    culoriTaskuri:new Utils().culoriTaskuri(),
    status:'',
        responsabil:1,
        nimicInEtape:'Nu sunt elemente in lista',
        useri:[],
        openInsert:false,
        menuOpen:false,
        elSelectat:{},
        isOpenMenuAvatar:false,
        listTaskuri:[],
        isOpenInsertTask:false,
        objInfoTask :{poza:'',statusul:'', titlu:this.dictionary.proiecte.etapeProiect.numeTask, nume:'', cand_ora:'00:00', pana_cand_ora:'00:00', descriere:this.dictionary.proiecte.etapeProiect.descriereTask, color:'rgb(108, 96, 197)'},
        strDataStart:this.dictionary.proiecte.etapeProiect.selectDate,
        strDataFinish:this.dictionary.proiecte.etapeProiect.selectDate,
        dtDataStart:new Date(),
        dtDataFinish:new Date(),
        isHiddenCalendarFinish:true,
        isHiddenCalendar:true,
        isOpenMenuEtape:false,
        objEtapaInfo:{denumire:'', note:'', durata_de_la:new Date() , durata_pana_la:null},
        isEtapaOpen:false,
        isOpenAlertDelete:false,
        strEtapaAlert:'',
        isOpenEtapaInsert:'',
        objInfoProiect:[],
        listSubTaskuri:[],
        isOpenEtapaInsert:false,
        isOpenAlertPerioadaTask:false,
        objPerioadaGantt:{},
        listProiecte:[],
        isOpenUtilizator:false,
        listEtapeAll:[],
        windowWidth:1000,
        monthView: true,
        etapaView:true,
        etapaViewTop:false,
        etapaSelectataView:false,
        taskSelectatView:false,
        objTaskSelectat:{id:0},
        objEtapaSelectata:{id:0, denumire:'', note:'', durata_de_la:new Date() , durata_pana_la:null},
        listTaskuriAll:[],
        objUser:{id:0},
        isOpenTimpiLucru:false,
        objTimpLucru:{
            data_introdusa:new Utils().defaultData(),
            nr_ore:'00',
            nr_minute:'00',
            zile_cumulate:0
        },
        listTimpiLucru:[]
 
}
    }

     componentDidMount(){

        window.addEventListener('resize',this.getWindowWidth)

        this.getData()
        this.getDetaliiUser()
      
    }

    getDetaliiUser = async()=>{
     

        let fs = new FromServer()

        let user = await fs.getDetaliiUser( this.props.match.params.iduser)

      
                                        // console.log('user :', user);
         if(user.r){
             this.setState({objUser:user.c[0],
                            },()=>{
                //  console.log('this.staet.objUser :', this.state.objUser);
             })
         }                
    }

    componentWillUnmount(){
        window.removeEventListener('resize',this.getWindowWidth)
    }

    getEtapaId = () =>{
        let ls = new LocalStorage();

        let etapa = ls.GetEtapaId();

        localStorage.removeItem('etapaId')

        // console.log('etapaSelectata :', etapa);

        if(etapa !== null){

            this.ganttChange.current.etapaClick(etapa)
        }

    }


    getWindowWidth = () =>{

        // console.log('window :', window.innerWidth);
        this.setState({windowWidth:window.innerWidth})
    }

   

    taskData = {}

    getData = async() =>{

        // console.warn('enterGet Data :')

        let fS = new FromServer();

        let ut = new Utils();

        let ws = new Ws()

        let _proiecte =  fS.getProiecte(this.props.match.params.iduser)

        let [ u,e, t, i,sT, p, eA, tA] =  await Promise.all([
                                                            fS.getUsers(this.props.match.params.idproiect),
                                                            fS.getEtape(this.props.match.params.idproiect), 
                                                            fS.getTaskuri(this.props.match.params.idproiect, this.props.match.params.iduser), 
                                                            fS.getInfoProiect(this.props.match.params.idproiect), 
                                                            fS.getSubTaskuri(this.props.match.params.idproiect,this.props.match.params.iduser), 
                                                            _proiecte, 
                                                            fS.getEtapeAll(), 
                                                            fS.getTaskuriAll(this.props.match.params.iduser) ])
      

       
        // console.log('e :',e);
        // console.log('u :',u);
        // console.log('t :', t);
        // console.log('i :', i);
        // console.log('sT :', sT);
        // console.log('p :', p);
        // console.log('eA :', eA);
        // console.log('tA :', tA);


        let tasks = t

        let cloneEtape = [...e]

        let subT = sT 

        let counter = t.length;

        let counter5 = subT.length

     
    //     for(let i =0 ; i< counter ; i++ ){

    //             if(tasks[i].statusul !== 'Finalizat'){
                 
    //              if ( new Date(ut.ParseDataFromSql(tasks[i].pana_cand_data)) <= new Date() ){
    //                 // console.log('colorTask :');
    //                 tasks[i].color = '#ff3f3f'
    //             }else if(new Date(ut.ParseDataFromSql(tasks[i].cand_data)) > new Date()){
    //                 tasks[i].color = 'rgb(251, 141, 0)'
    //             }else{
    //                 tasks[i].color = 'rgb(58, 180, 209)'
    //             }
    //     }else{
    //         tasks[i].color = 'rgb(122, 209, 58)' 
    //     }

        

    // }

        for(let i =0 ; i< counter5 ; i++ ){

                if(subT[i].statusul !== 'Finalizat'){
                 
                 if ( new Date(ut.ParseDataFromSql(subT[i].pana_cand_data)) <= new Date() ){
                    // console.log('colorTask :');
                    subT[i].color = '#ff3f3f'
                }else if(new Date(ut.ParseDataFromSql(subT[i].cand_data)) > new Date()){
                    subT[i].color = 'rgb(58, 180, 209)'
                }else{
                    subT[i].color = 'rgb(251, 141, 0)'
                }
        }else{
            subT[i].color = 'rgb(122, 209, 58)' 
        }

        

    }

        for(let i =0 ; i< counter ; i++ ){

                if(tasks[i].statusul !== 'Finalizat'){

                    let filterSubT = subT.filter(st => st.id_task_parent === tasks[i].id)
                  
                    if(filterSubT.length > 0){
                        filterSubT = filterSubT.filter(t => t.statusul !== 'Finalizat')

                        let subTTrecute = filterSubT.filter(t => new Date(ut.ParseDataFromSql(t.pana_cand_data)) <= new Date() )
                        let subTInViitor = filterSubT.filter(t => new Date(ut.ParseDataFromSql(t.cand_data)) > new Date() )
                        if(tasks[i].id === 32){
                            // console.log('filterSubT :', filterSubT);
                            // console.log('filterSubT :', subTInViitor);
                        }

                        if(filterSubT.length > 0){
                            if(subTTrecute.length > 0){
                                if(tasks[i].id === 32){
                                    // console.log('filterSubT :', subTTrecute);
                                }
                                tasks[i].color = '#ff3f3f'
                            }else if(filterSubT.length === subTInViitor.length){
                               
                                tasks[i].color ='rgb(58, 180, 209)'
                            }else{
                                tasks[i].color = 'rgb(251, 141, 0)'
                            }
                
                        }else{
                            tasks[i].color = 'rgb(122, 209, 58)' 
                        }
                        
                    }else{

                        if ( new Date(ut.ParseDataFromSql(tasks[i].pana_cand_data)) <= new Date() ){
                           // console.log('colorTask :');
                           tasks[i].color = '#ff3f3f'
                       }else if(new Date(ut.ParseDataFromSql(tasks[i].cand_data)) > new Date()){
                           tasks[i].color = 'rgb(58, 180, 209)'
                       }else{
                           tasks[i].color = 'rgb(251, 141, 0)'
                       }
                    }
                 
        }else{
            tasks[i].color = 'rgb(122, 209, 58)' 
        }
    }

   

    

    let counter2 = cloneEtape.length

    for(let i = 0; i< counter2; i++){
        let filterTaskuri = tasks.filter(t => t.id_etapa_proiect === cloneEtape[i].id)

         filterTaskuri = filterTaskuri.filter(t =>( new Date(ut.ParseDataFromSql(t.cand_data)) < new Date(cloneEtape[i].durata_pana_la) && new Date(ut.ParseDataFromSql(t.pana_cand_data)) < new Date(cloneEtape[i].durata_pana_la) ))


        filterTaskuri = filterTaskuri.filter(t => t.pana_cand_data !== null)
        

        filterTaskuri = filterTaskuri.filter(t => t.statusul !== 'Finalizat')

    


        let taskuriTrecute = filterTaskuri.filter(t => new Date(ut.ParseDataFromSql(t.pana_cand_data)) <= new Date() )

        let taskuriInViitor= filterTaskuri.filter(t => new Date(ut.ParseDataFromSql(t.cand_data)) > new Date() )

        if(filterTaskuri.length > 0){
            if(taskuriTrecute.length > 0){
                cloneEtape[i].color = '#ff3f3f'
            }else if(filterTaskuri.length === taskuriInViitor.length){
                cloneEtape[i].color ='rgb(58, 180, 209)'
            }else{
                cloneEtape[i].color = 'rgb(251, 141, 0)'
            }

        }else{
            cloneEtape[i].color = 'rgb(122, 209, 58)' 
        }



        //     cloneEtape[i].color = '#ff3f3f'
        // }else if (filterTaskuri.length > 0){
        //     cloneEtape[i].color = 'rgb(247, 167, 16)'
        // }else{
        //     cloneEtape[i].color = '#7ad13a'
        // }

    }

    let cloneEtapeAll = [...eA]

            

    let cloneTaskuri = [...tA]

    let counter4 = cloneEtapeAll.length

    for(let i = 0; i< counter4; i++){
        let filterTaskuri = cloneTaskuri.filter(t => t.id_etapa_proiect === cloneEtapeAll[i].id)

        filterTaskuri = filterTaskuri.filter(t =>( new Date(ut.ParseDataFromSql(t.cand_data)) < new Date(cloneEtapeAll[i].durata_pana_la) && new Date(ut.ParseDataFromSql(t.pana_cand_data)) < new Date(cloneEtapeAll[i].durata_pana_la) ))
                
        
        filterTaskuri = filterTaskuri.filter(t => t.pana_cand_data !== null)
        
        filterTaskuri = filterTaskuri.filter(t => t.statusul !== 'Finalizat')

       


        let taskuriTrecute = filterTaskuri.filter(t => new Date(ut.ParseDataFromSql(t.pana_cand_data)) <= new Date() )

        let taskuriInViitor= filterTaskuri.filter(t => new Date(ut.ParseDataFromSql(t.cand_data)) > new Date() )

        if(filterTaskuri.length > 0){
            if(taskuriTrecute.length > 0){
                cloneEtapeAll[i].color = '#ff3f3f'
            }else if(filterTaskuri.length === taskuriInViitor.length){
                cloneEtapeAll[i].color ='rgb(58, 180, 209)'
            }else{
                cloneEtapeAll[i].color = 'rgb(251, 141, 0)'
            }

        }else{
            cloneEtapeAll[i].color = 'rgb(122, 209, 58)' 
        }



        //     cloneEtape[i].color = '#ff3f3f'
        // }else if (filterTaskuri.length > 0){
        //     cloneEtape[i].color = 'rgb(247, 167, 16)'
        // }else{
        //     cloneEtape[i].color = '#7ad13a'
        // }

    }



    let cloneProiecte = [...p.Content]

    let counter3= cloneProiecte.length

    let perioadaDeLa = ut.defaultData()

    let perioadaPanaLa = ut.defaultDataPlus3Months();

    for( let i = 0 ; i< counter3; i++){

      
        cloneProiecte[i].perioada_dela = ut.ParseDataFromSql(cloneProiecte[i].perioada_dela)
        cloneProiecte[i].perioada_panala = ut.ParseDataFromSql(cloneProiecte[i].perioada_panala)
    }

    for(let i = 0 ; i< counter3; i++){
        if(new Date(cloneProiecte[i].perioada_dela)  < new Date(perioadaDeLa) ){
            perioadaDeLa = cloneProiecte[i].perioada_dela
        }
        
        if( new Date(cloneProiecte[i].perioada_panala) > new Date(perioadaPanaLa)){
            perioadaPanaLa = cloneProiecte[i].perioada_panala
        }
    }
//   console.log('etapaSelectatanou :', this.state.objEtapaSelectata);

// console.log('cloneEtape :', cloneEtapeAll);

        // console.log('tasks  :', tasks );

        let etapaSelectata=[]
        if(this.state.objEtapaSelectata){

             etapaSelectata = cloneEtapeAll.filter(e => e.id === this.state.objEtapaSelectata.id)
        }


     
        if(etapaSelectata.length ===0){
            etapaSelectata = [{id:0, denumire:'', note:'', durata_de_la:new Date() , durata_pana_la:null}]
        }
           
  
       
            this.setState({etape:e,
                            listTaskuri:tasks,
                            objInfoProiect:i,
                            objEtapaSelectata:etapaSelectata[0],
                            listSubTaskuri:subT,
                            listEtapeAll:cloneEtapeAll,
                            objPerioadaGantt:{dtPerioadaDeLa:perioadaDeLa, dtPerioadaPanaLa:perioadaPanaLa},
                            listProiecte:cloneProiecte,
                            listTaskuriAll:tA,
                            useri:u
                            },
                        ()=>{
                            // console.log('etapeLength :', this.state.etape.length);
                            // console.log('this.state.objInfoProiect :', this.state.objInfoProiect);
                            this.getEtapaId()
                        })
        


      
    }


   

   

   

    






    


    getTaskData =async(t,e,slide=false)=>{
        // console.log('t :', t);
        // console.warn('etapaselectata :', e);

            let u = new Utils()

        let el = t
        el.descriere = t.descriere || this.dictionary.proiecte.etapeProiect.descriereTask

        //  console.warn('el :', el);

         let fs = new FromServer();

         let getTimpiLucru = await fs.getTaskuriTimpiLucru(el.id_utilizator_responsabil, t.id)

        //  console.warn('getTimpiLucru---------------- :', getTimpiLucru);

         if(getTimpiLucru.Succes){

            let timpiLucru = getTimpiLucru.Content

            let counter = timpiLucru.length

            for(let i = 0; i< counter; i++){
                timpiLucru[i].data_introdusa = u.ParseDataFromSql(timpiLucru[i].data_introdusa)
            }

            this.setState({
                isOpenInsertTask: slide === true ? false : true,
                objInfoTask:el,
                            strDataStart: t.cand_data !== null ? ( this.dictionary.data === 'en' ? u.dataPrescurtataEng(u.ParseDataFromSql(t.cand_data)) :  u.dataPrescurtataRomana(u.ParseDataFromSql(t.cand_data)) ) :this.dictionary.proiecte.etapeProiect.selectDate ,
                            strDataFinish : t.pana_cand_data !== null ? ( this.dictionary.data === 'en' ? u.dataPrescurtataEng(u.ParseDataFromSql(t.pana_cand_data)) :  u.dataPrescurtataRomana(u.ParseDataFromSql(t.pana_cand_data))) : this.dictionary.proiecte.etapeProiect.selectDate,
                            dtDataStart: t.cand_data !== null ? new Date(t.cand_data) : new Date(),
                            dtDataFinish: t.pana_cand_data !== null ? new Date(t.pana_cand_data) : new Date(),
                            listTimpiLucru:timpiLucru,
                            objEtapaInfo:e 
                        })
         }




    }

    getGanttTaskData =(t) =>{

        let cloneEtape = [...this.state.etape]

        let idx = cloneEtape.findIndex(e=>e.id === t.id_etapa_proiect)

        let u = new Utils()

        let el = t
        el.descriere = t.descriere || this.dictionary.proiecte.etapeProiect.descriereTask

        // console.log('el :', el);
        this.setState({objInfoTask:el,
                        strDataStart: t.cand_data !== null ? ( this.dictionary.data === 'en' ? u.dataPrescurtataEng(u.ParseDataFromSql(t.cand_data)) :  u.dataPrescurtataRomana(u.ParseDataFromSql(t.cand_data)) ) :this.dictionary.proiecte.etapeProiect.selectDate ,
                        strDataFinish : t.pana_cand_data !== null ? ( this.dictionary.data === 'en' ? u.dataPrescurtataEng(u.ParseDataFromSql(t.pana_cand_data)) :  u.dataPrescurtataRomana(u.ParseDataFromSql(t.pana_cand_data))) : this.dictionary.proiecte.etapeProiect.selectDate,
                        dtDataStart: t.cand_data !== null ? new Date(t.cand_data) : new Date(),
                        dtDataFinish: t.pana_cand_data !== null ? new Date(t.pana_cand_data) : new Date(),
                        isOpenInsertTask:true,
                        objEtapaInfo:cloneEtape[idx]
                    })


    }


   




taskFinalizat = async() =>{
    let fs =new FromServer();

    let ut = new Utils()

    let obj ={ 
        statusul: this.state.objInfoTask.statusul !== 'Finalizat'  ? 'Finalizat' : 'In Lucru'
    }

    // console.log('this.state.objEta-------s-d-s-d-sd-s-d------dsd-s-sd :', this.state.objEtapaInfo);

    // console.log('titlu :', obj.statusul);

    let update = await  fs.updateTask(obj, this.state.objInfoTask.id )

    if(update){

        let cloneTaskuri = [...this.state.listTaskuriAll]

        let filterTaskuri = cloneTaskuri.filter(t => t.id_etapa_proiect === this.state.objEtapaInfo.id )


        let idx = filterTaskuri.findIndex(f => f.id === this.state.objInfoTask.id)

       

        filterTaskuri[idx].statusul = obj.statusul

        let objCloneTask = {...this.state.objInfoTask}
        objCloneTask.statusul = obj.statusul

        let getStatus = filterTaskuri.filter(st=> st.statusul !== 'Finalizat')

        let status =''

        if(getStatus.length > 0 ){
            status = 'In Lucru'
        }else{
            status = 'Finalizat'
        }


        let etapaSts = {
            statusul:status
        }


        // console.log('filterTaskuri :', filterTaskuri);
        
        let updateEtapa = await fs.updateEtapa(etapaSts, this.state.objEtapaInfo.id)



        if(updateEtapa){

            let  cloneTask = {...this.state.objTaskSelectat}

            cloneTask.statusul = obj.statusul

            if(obj.statusul !== 'Finalizat'){
                 
                if ( new Date(ut.ParseDataFromSql(cloneTask.pana_cand_data)) <= new Date() ){
                   // console.log('colorTask :');
                   cloneTask.color = '#ff3f3f'
               }else if(new Date(ut.ParseDataFromSql(cloneTask.cand_data)) > new Date()){
                cloneTask.color = 'rgb(251, 141, 0)'
               }else{
                cloneTask.color = 'rgb(58, 180, 209)'
               }
       }else{
        cloneTask.color = 'rgb(122, 209, 58)' 
       }

         

            this.setState({objInfoTask:objCloneTask, objTaskSelectat:cloneTask },()=>{
                this.getData()
            })
           
        }




      
    }
}




      colorChange=(ev)=>{
        //   console.log('ev.target.value :', ev.target.value);


        //   console.log('this.state.obtask :', this.state.objInfoTask);

          let fs = new FromServer();

          let cloneTaskuri = [...this.state.listTaskuri]

          let idx = cloneTaskuri.findIndex(c => c.id === this.state.objInfoTask.id)

          cloneTaskuri[idx].color = ev.target.value

         let cloneObjTaskInfo = {...this.state.objInfoTask}

         cloneObjTaskInfo.color = ev.target.value
          let obj = {
              color:ev.target.value
          }

          let updateTask = fs.updateTask(obj,this.state.objInfoTask.id)

          if(updateTask){
              this.setState({listTaskuri:cloneTaskuri,
                            objInfoTask:cloneObjTaskInfo
                                },()=>{
                  this.getData()
              })
          }


      }



      changeViewEtape = (is, e) =>{
        //   console.log('e :', e);
        //   console.log('is :', is);
          this.setState({monthView:is,
                         objEtapaSelectata:e,
                        etapaViewTop: is === false ? true : false,
                        taskSelectatView:false,
                        etapaSelectataView: is === false ? true : false,
                        etapaView:is})
      }

      changeTaskView =(t) =>{
        //   console.log('t :', t);

          this.setState({objTaskSelectat:t,
                        taskSelectatView:true,
                        etapaSelectataView:false
                        })
      }

      goToTaskView = (t, e)=>{
          this.setState({monthView:false,
                        objEtapaSelectata:e,
                        etapaViewTop:true,
                        taskSelectatView:true,
                        etapaSelectataView:false,
                        objTaskSelectat:t,
                        etapaView:false
                        })
      }

      openTimpEstimatLucru =() =>{
            this.setState({isOpenTimpiLucru:true})
      }


    changeDate=(e,ev)=>{
        // console.log('e :', e);
        // console.log('ev.target.value :', ev.target.value);

        let cloneTimpi = [...this.state.listTimpiLucru]

        let idx = cloneTimpi.findIndex(i => i.id === e.id)

        cloneTimpi[idx].data_introdusa = ev.target.value
        this.setState({
            listTimpiLucru:cloneTimpi
        })
    }

    updateDateTimpi =async(t)=>{
        

        let ws = new Ws();

        let updateDateTimpi = ws.update('taskuri_timpi_lucru',{data_introdusa:t.data_introdusa},{id:t.id})
        if(updateDateTimpi.Succes){
            // console.log('nivelUpdate succes :');
            this.getTaskData(this.state.objInfoTask,this.state.objEtapaInfo)
        }
    }

    changeOreTimpi = (e,ev)=>{
        // console.log('e :', e);
        // console.log('ev.target.value :', ev.target.value);

        let cloneTimpi = [...this.state.listTimpiLucru]

        let idx = cloneTimpi.findIndex(i => i.id === e.id)

        cloneTimpi[idx].nr_ore = ev.target.value
        this.setState({
            listTimpiLucru:cloneTimpi
        })
    }

    updateOreTimpi = async(t) =>{
        let ws = new Ws();

        let updateDateTimpi = ws.update('taskuri_timpi_lucru',{nr_ore:t.nr_ore},{id:t.id})
        if(updateDateTimpi.Succes){
            // console.log('nivelUpdate succes :');
            this.getTaskData(this.state.objInfoTask,this.state.objEtapaInfo)
        }
    }

    changeMinuteTimpi = (e,ev)=>{
        // console.log('e :', e);
        // console.log('ev.target.value :', ev.target.value);

        let cloneTimpi = [...this.state.listTimpiLucru]

        let idx = cloneTimpi.findIndex(i => i.id === e.id)

        cloneTimpi[idx].nr_minute = ev.target.value
        this.setState({
            listTimpiLucru:cloneTimpi
        })
    }

    updateMinuteTimpi= async(t) =>{
        let ws = new Ws();

        let updateDateTimpi = ws.update('taskuri_timpi_lucru',{nr_minute:t.nr_minute},{id:t.id})
        if(updateDateTimpi.Succes){
            // console.log('nivelUpdate succes :');
            this.getTaskData(this.state.objInfoTask,this.state.objEtapaInfo)
        }
    }

    changeTimpLucruData = n=>ev =>{

        let cloneTimpLucru = {...this.state.objTimpLucru}

        cloneTimpLucru[n] = ev.target.value

        this.setState({objTimpLucru:cloneTimpLucru})

    }

    insertTimpLucru =async(t)=> {
        // console.log('t :', t);

        let ws = new Ws();


        let objToInsert ={
            id_user:this.state.objInfoTask.id_utilizator_responsabil,
            data_introducerii:new Utils().defaultData(),
            nr_ore:t.nr_ore,
            id_task:this.state.objInfoTask.id,
            nr_minute:t.nr_minute,
            zile_cumulate:t.zile_cumulate,
            data_introdusa:t.data_introdusa 
        }

        let insert =await ws.insert('taskuri_timpi_lucru',objToInsert)

        if(insert.Succes){

            // console.log('insertSuccess :');
            this.getTaskData(this.state.objInfoTask,this.state.objEtapaSelectata)
        }
    }

    changeZileCumulate=(ev)=>{

        let cloneTimpi = {...this.state.objTimpLucru}


        cloneTimpi.zile_cumulate= ev.target.checked === true ? 1 : 0

        this.setState({objTimpLucru:cloneTimpi})

    }

    deleteTimp =async (t) =>{
        let ws = new Ws();

        let deleteTimp = await ws.update('taskuri_timpi_lucru',{sters:1},{id:t.id})

        if(deleteTimp.Succes){
            this.getTaskData(this.state.objInfoTask,this.state.objEtapaSelectata)
        }
    }

    goToUser=()=>{
       

        
             this.props.history.push(`/infouser/${this.state.objUser.id}`)
         
     }

     changeUser=(ev)=>{

        // console.log('ev.target.value :', ev.target.value);
        this.props.history.push(`/userprojects/${ev.target.value}`)
     }
    
     render() { 
       return (
           <div >
           <AppBar history={this.props.history} title={this.dictionary.appBar.drawer.etapeUser} />
           <div style={{width:'100%', overflow:'scroll', position:'relative', marginTop:50}}>
          <div  style={{ marginTop:20, textAlign:'left', height:'100%', display:'flex', position:'absolute'}}>
              {/* <Fab  onClick={()=>{this.setState({openInsert:true})}} className="pm-round-button">
                                      <i className='material-icons pm-round-button-text'>add</i>
                            </Fab> */}

                            <AlertDialog
                                            open={this.state.isOpenAlertPerioadaTask}
                                            dialogClose={()=>{this.setState({isOpenAlertPerioadaTask:false})}}
                                            title={this.dictionary.alertDate.task}
                                            limba={this.dictionary}
                                            yesFunction = {()=>{this.setState({isOpenAlertPerioadaTask:false})}}
                                            noButtonDisplay = {1}
                    /> 

                    <TimpiLucru 
                        open={this.state.isOpenTimpiLucru}
                        dialogClose={()=>{this.setState({isOpenTimpiLucru:false})}}
                        task={this.state.objInfoTask}
                        getTimpiLucru={()=>{this.getTaskData(this.state.objInfoTask,this.state.objEtapaSelectata )}}
                        timpiLucru={this.state.listTimpiLucru}
                        changeDate={this.changeDate}
                        updateDateTimpi={this.updateDateTimpi}
                        limba={this.dictionary}
                        timpLucru={this.state.objTimpLucru}
                        changeData={this.changeTimpLucruData}
                        insertTimpLucru={this.insertTimpLucru}
                        changeOreTimpi={this.changeOreTimpi}
                        updateOreTimpi={this.updateOreTimpi }
                        changeMinuteTimpi={this.changeMinuteTimpi }
                        updateMinuteTimpi={this.updateMinuteTimpi}
                        changeZileCumulate={this.changeZileCumulate}
                        deleteTimp={this.deleteTimp}

                    />

                    

                            <InsertUpdateTask
                                    userView={true}
                                    open={this.state.isOpenInsertTask}
                                    dialogClose={()=>{this.setState({isOpenInsertTask:false,  
                                                                    objInfoTask :{statusul:'', titlu:this.dictionary.proiecte.etapeProiect.numeTask, nume:'', cand_ora:'00:00', pana_cand_ora:'00:00', descriere:this.dictionary.proiecte.etapeProiect.descriereTask, color:''},
                                                                    dtDataStart:new Date(),
                                                                    dtDataFinish:new Date(),
                                                                    strDataStart:this.dictionary.proiecte.etapeProiect.selectDate,
                                                                    strDataFinish:this.dictionary.proiecte.etapeProiect.selectDate,
                                },async()=>{await this.getData()})}}
                                    taskCompletat={this.state.objInfoTask.statusul}
                                    taskFinalizat={this.taskFinalizat}
                                    dictionary={this.dictionary}
                                    dataStart={this.state.strDataStart}
                                    dataFinish={this.state.strDataFinish}
                                    dtDataStart={this.state.dtDataStart}
                                    dtDataFinish={this.state.dtDataFinish}
                                    hideCalendarFinish={this.state.isHiddenCalendarFinish}
                                    hideCalendar={this.state.isHiddenCalendar}
                                    showCalendarStart={()=>{this.setState({isHiddenCalendar:true,isHiddenCalendarFinish:true})}}
                                    showCalendarFinish={()=>{this.setState({isHiddenCalendarFinish:true, isHiddenCalendar:true})}}
                                     hideCal={this.hideCal}
                                     dataStartChange={(ev) =>{this.dataStartChange(ev)}}
                                     dataFinishChange={(ev) =>{this.dataFinishChange(ev)}}
                                     taskTitle={this.state.objInfoTask.titlu}
                                    taskTitleChange={(ev)=>{console.log('object :', ev.target.value);}}
                                    updateTaskTitle={this.updateTaskTitle}
                                    listEtape={this.state.etape}
                                    listTaskuri={this.state.listTaskuri}
                                    getData={this.getData}
                                    isOpenMenuEtape={this.state.isOpenMenuEtape}
                                    closeMenuEtape={this.closeEtape}
                                    etapaTitle={this.state.objEtapaInfo.denumire}
                                    etapeClick={this.etapeClick}
                                    objInfoTask={this.state.objInfoTask}
                                    listUsers={this.state.useri}
                                    isUtlizatorOpen={this.state.isOpenUtilizator}
                                    closeUtilizator = {this.closeUtilizator}
                                    userClick = {this.openUserMenu}
                                    listSubTaskuri={this.state.listSubTaskuri}
                                    candOra = {this.state.objInfoTask.cand_ora}
                                    candOraChange={(ev)=>{console.log('object :', ev.target.value);}}
                                    panaCandOra={this.state.objInfoTask.pana_cand_ora}
                                    panaCandOraChange={(ev)=>{console.log('object :', ev.target.value);}}
                                    updateTaskCandOra={this.updateTaskCandOra}
                                    updateTaskPanaCandOra ={this.updateTaskPanaCandOra}
                                    taskDescription={this.state.objInfoTask.descriere}
                                    taskDescriptionChange={(ev)=>{console.log('object :', ev.target.value);}}
                                    updateTaskDescription={this.updateTaskDescription}
                                    deleteTask={this.deleteTask}
                                    colorChange={this.colorChange}
                                    culoriTaskuri={this.state.culoriTaskuri}
                                    openListTimpEstimatLucru={this.openTimpEstimatLucru}


                                    />


                             

                                    <AlertDialog
                                            open={this.state.isOpenAlertDelete}
                                            dialogClose={()=>{this.setState({isOpenAlertDelete:false})}}
                                            title={this.state.strEtapaAlert}
                                            limba={this.dictionary}
                                            yesFunction = {this.stergeEtapa}
                    />           
{

}
            {/* {this.state.etape.map((e,idx)=>{
                return (
                 

                 
                    <EtapeListBeta
                            key={idx}
                            titlu={e.denumire}
                            dict={this.dictionary}
                            listTaskuri={this.state.listTaskuri}
                            listSubTaskuri={this.state.listSubTaskuri}
                            getTaskData={this.getTaskData}
                            dragEndTask={this.dragEndTask}
                            editEtapa={this.editEtapa}
                            deleteEtapa={this.deleteEtapa}
                            dragStart ={this.dragStart}
                            dragOverEt={this.dragOverEt}
                            dropEt={this.dropEt}
                            etapa={e}
                            addNewEtapa={this.addNewEtapa}
                            addNewTask={this.addNewTask}
                           
                            />
                    
                )
            })}    */}

            {/* <EtapeListBeta
                            titlu={null}
                            addNewEtapa={()=>{this.setState({isOpenEtapaInsert:true})}}
                            dict={this.dictionary} />      */}
                            </div>        
        {/* {this.state.etape.length === 0 && 
            <h3>{this.state.nimicInEtape}</h3>
        }
        {this.state.etape.length > 0 && 
        <EtapeList 
           elemente={this.state.etape}
           dict={this.dictionary}
           status={this.state.etapeStatus}
           changeTitle={this.changeTitle}
           changeNote={this.changeNote}
           openMenuAvatar={this.state.isOpenMenuAvatar}
           openMenu={this.state.menuOpen}
           changeTimer={this.changeTimer}
           elSelectat={this.state.elSelectat}
                closeMenu={this.closeMenuStatus}
                closeMenuAvatar={this.closeMenuAvatar}
                users={this.state.useri}
                avatarClick={this.avatarClick}
           elementSelectat={this.onEtapaClick}
           onlyColumns = {{title:'denumire', idUser:'id_user_responsabil', dataStart:'durata_de_la', dataFinish:'durata_pana_la', statusul:'statusul'}}
           />    
    } */}
    <Grid style={{height:'30vh', width:'95%', margin:'auto'}}  container>
    
        
                           
        <Grid style={{borderRight:'1px dashed gray', textAlign:'left'}} item xs={12} sm={12} md={2} lg={2} xl={2}>

       
       <div
       onClick={this.goToUser}
       style={{
                width: 100,
                height: 100,
                backgroundImage: `url(${this.state.objUser.poza ? (new Ws().adresaMedia + '/Angajati/' + this.state.objUser.poza )  : avatar })`,
                backgroundRepeat: 'no-reapeat',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                display: 'inline-block'
            }}>

            </div>


            <div className='pm-user-info'>

                <h3 style={{ marginBottom: 0, textAlign: 'left', marginTop: 0 }} className='pm-title'>{this.state.objUser.nume}</h3>
                <h5 style={{ marginTop: 5, textAlign: 'left' }} className='pm-title'>Manager</h5>
            </div>


            <h4 style={{ marginBottom: 0, textAlign: 'left', marginTop: 0 }} className='pm-title'>Email: {this.state.objUser.email}</h4>
       
        <div style={{marginTop:10}}>
                         

                         <div style={{textAlign:'left'}}>
                             <div style={{backgroundColor:'rgb(122, 209, 58)'}} className='pm-task-legend'></div>
                             <span className='pm-title'>{this.dictionary.proiecte.status.finalizata}</span>
                         </div>
                         <div style={{textAlign:'left'}}>
                             <div style={{backgroundColor:'red'}} className='pm-task-legend'></div>
                             <span className='pm-title'>{this.dictionary.proiecte.status.blocat}</span>
                         </div>
                         <div style={{textAlign:'left'}}>
                         <div style={{backgroundColor:'rgb(58, 180, 209)'}} className='pm-task-legend'></div>
                             <span className='pm-title'>{this.dictionary.proiecte.status.inviitor}</span>
                         </div>
                         <div style={{textAlign:'left'}}>
                           
                             <div style={{backgroundColor:'rgb(251, 141, 0)'}} className='pm-task-legend'></div>
                             <span className='pm-title'>{this.dictionary.proiecte.status.inlucru}</span>
                         </div>
                         </div>

                <FormControl className='inputFocus' style={{ width:'80%', margin:'20px auto'}} >
                        <InputLabel   htmlFor="useri">
                        {this.dictionary.proiecte.etapeProiect.selecteazaUser}
                        </InputLabel>
                        <Select
                    
                        value={this.state.objUser.id}
                        onChange={(ev)=>{this.changeUser(ev)}}
                        input={<Input id="useri" />}>
                        >
                        {this.state.useri.map((c,idx)=>{
                            return(
                                <MenuItem  key={idx} value={c.id}>{c.nume}</MenuItem>
                            )
                        })}
                        </Select>
                    </FormControl>
                        

       
        </Grid>
        <Grid style={{position:'relative'}} item xs={12} sm={12} md={9} lg={9} xl={9}>
        <h3 style={{width:'fit-content', margin:'auto', borderBottom:'1px solid gray', display:this.state.etapaViewTop ? 'none' : 'block' }} className='pm-title'>{new Utils().dataAzi()}</h3>
                            <div style={{height:'100%', position:'absolute', left:0, right:0, margin:'auto', width:1, backgroundColor:'#e0e0e0', display:this.state.etapaViewTop ? 'none' : 'block'}}></div>
        {
            this.state.monthView &&
        <GanttProiecteMonthView
                    idUser={this.props.match.params.iduser}
                    objPerioadaGantt={this.state.objPerioadaGantt}
                     listEtape={this.state.listEtapeAll}
                     listProiecte={this.state.listProiecte}
                     history={this.props.history}
                     dictionary={this.dictionary}
                     idProiect={this.state.objInfoProiect}
                   
                            />
        }

        {this.state.objInfoProiect.length>0 && this.state.etapaViewTop && 
                        <div style={{height:'100%', }}>
                            <GanttProiectIntegral
                            objProiectInfo={this.state.objInfoProiect}
                            dictionary={this.dictionary}
                            listEtape={this.state.etape}
                            screenLimit={this.state.windowWidth > 800 ? 30 : 12}
                            listTaskuri={this.state.listTaskuri}
                            idTask ={this.state.objTaskSelectat.id}
                            changeView={this.changeViewEtape}
                            goToTask={this.goToTaskView}
                            displayInsert={1}
                            listSubTaskuri={this.state.listSubTaskuri}
                            idEtapa={this.state.objEtapaSelectata.id}
                            />

                          

                        </div>
                }
        </Grid>
       
    
    </Grid>

  

       
            

         </div>

         <Grid container >
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>

             {this.state.objInfoProiect.length>0 &&
                <TaskuriList 
                    listTaskuri={this.state.listTaskuri}
                    listSubtaskuri ={this.state.listSubTaskuri}
                    listEtape={this.state.etape}
                    dict={this.dictionary}
                    onTaskClick={this.getTaskData}
                    etapaInfo={this.state.objEtapaSelectata}
                    objProiectInfo={this.state.objInfoProiect}
                    />
             }
                </Grid>

                <Grid item xs={12} sm={12} md={9} lg={9} xl={9}>

                {this.state.objInfoProiect.length>0 && this.state.etapaView && 
                        <div style={{height:'60vh', }}>
                            <GanttProiectIntegral
                            objProiectInfo={this.state.objInfoProiect}
                            dictionary={this.dictionary}
                            listEtape={this.state.etape}
                            displayInsert={1}
                            screenLimit={this.state.windowWidth > 800 ? 30 : 12}
                            listTaskuri={this.state.listTaskuri}
                            changeView={this.changeViewEtape}
                            goToTask={this.goToTaskView}
                            insertEtapa={()=>{this.setState({isOpenEtapaInsert:true})}}
                            listSubTaskuri={this.state.listSubTaskuri}
                           
                            />

                          

                        </div>
                }

                {
                   this.state.etapaSelectataView &&

                    <GanttEtapeMonthView
                    userView={true}
                        objProiectInfo={this.state.objInfoProiect}
                        objEtapaSelectata={this.state.objEtapaSelectata}
                        screenLimit={this.state.windowWidth > 800 ? 30 : 12}
                        dictionary={this.dictionary}
                        displayInsert={1}
                        listTaskuri={this.state.listTaskuri}
                        listSubTaskuri={this.state.listSubTaskuri}
                        editTask = {this.getTaskData}
                        goToTask = {this.changeTaskView}
                        editEtapa={()=>{console.log('addEtapa :');}}
                        insertTask={()=>{console.log('addEtapa :');}}
                        changePanaCandData={this.dataFinishChange}
                        changeCandData={this.dataStartChange}
                            />
                }

                {
                    this.state.taskSelectatView &&
                    <GanttTaskuriFullView
                    userView={true}
                    objEtapaSelectata={this.state.objEtapaSelectata}
                        objTaskSelectat ={this.state.objTaskSelectat}
                        screenLimit={this.state.windowWidth > 800 ? 30 : 12}
                        dictionary={this.dictionary}
                        listSubTaskuri={this.state.listSubTaskuri}
                        editTask = {this.getTaskData}
                        goToTask = {this.changeTaskView}
                    />
                }
                </Grid>

         </Grid>
                
         {/* <div style={{width:'100%', overflow:'hidden'}}>
          <div id='pm-gantt-etape-container'  style={{ marginTop:20, overflowX:'scroll', overflowY:'hidden', textAlign:'left', height:'100%', display:'flex', position:'relative'}}>
          {this.state.listTaskuri.length > 0 &&
        
        
          <GanttEtapeWeekView
            objInfoProiect={this.state.objInfoProiect}
            listTaskuri={this.state.listTaskuri}
            listSubtaskuri={this.state.listSubTaskuri}
            etape={this.state.etape}
            dictionary={this.dictionary}
            OpenTask={this.getGanttTaskData}
            getData={this.getData}
            ref={this.ganttChange}
                    />

     
        }
          </div>
          </div> */}
         </div>
        );
       }
}